// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Textarea-SecondLabel.module.scss  */
.Textarea-SecondLabel-module-Root_xQ4 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px; }
  .Textarea-SecondLabel-module-Root_xQ4 label {
    display: flex;
    align-items: flex-start;
    width: 100%;
    font-family: var(--textarea-font-family);
    font-size: 0.875rem;
    line-height: 1.4;
    color: var(--color-control-label);
    grid-gap: 0 4px; }
  .Textarea-SecondLabel-module-Root_xQ4 span {
    font-family: var(--textarea-font-family);
    font-size: 0.875rem;
    line-height: 1.4;
    color: var(--color-control-label); }

.Textarea-SecondLabel-module-required_2ZC {
  font-size: 0.5rem;
  color: var(--color-control-label); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Textarea/SecondLabel/Textarea-SecondLabel.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB,EAAE;EACpB;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC,eAAe,EAAE;EACnB;IACE,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC,EAAE;;AAEvC;EACE,iBAAiB;EACjB,iCAAiC,EAAE","sourcesContent":["/*  imported from Textarea-SecondLabel.module.scss  */\n.Textarea-SecondLabel-module-Root_xQ4 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px; }\n  .Textarea-SecondLabel-module-Root_xQ4 label {\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n    font-family: var(--textarea-font-family);\n    font-size: 0.875rem;\n    line-height: 1.4;\n    color: var(--color-control-label);\n    grid-gap: 0 4px; }\n  .Textarea-SecondLabel-module-Root_xQ4 span {\n    font-family: var(--textarea-font-family);\n    font-size: 0.875rem;\n    line-height: 1.4;\n    color: var(--color-control-label); }\n\n.Textarea-SecondLabel-module-required_2ZC {\n  font-size: 0.5rem;\n  color: var(--color-control-label); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
